import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { logger } from '@sentry/react';
import { PATHS } from 'config/paths';
import { getTrans } from 'modules/i18n';
import { ErrorScreen } from '../parts/ErrorScreen';

const isDynamicImportError = (error: any): boolean =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  error?.message?.includes('Failed to fetch dynamically imported module');

const isAssetMismatchError = (error: any): boolean =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  error?.message?.includes("'text/html' is not a valid JavaScript MIME type.");

export const ErrorFallbackScreen = () => {
  const error = useRouteError();

  useEffect(() => {
    if (isDynamicImportError(error)) {
      logger.warn('ErrorFallbackScreen displayed due to dynamic import errors');
    } else if (isAssetMismatchError(error)) {
      logger.warn('ErrorFallbackScreen displayed due to asset mismatch errors');
    } else {
      logger.warn('ErrorFallbackScreen displayed');
    }
  }, [error]);

  return (
    <ErrorScreen
      title={getTrans('crashScreen.title1')}
      description1={getTrans('crashScreen.body1')}
      description2={getTrans('crashScreen.body2')}
      buttonText={getTrans('crashScreen.buttonTitle')}
      onButtonClick={() => (window.location.href = PATHS.root)}
    />
  );
};
